(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const select = (tab) => {
      const root = tab.closest('.collection-tabs');
      if (!root) return;

      root.querySelectorAll('[data-collection-tab]').forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;

        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !isActive;
      });
    };

    document.addEventListener('click', (event) => {
      const tab = event.target.closest && event.target.closest('[data-collection-tab]');
      if (tab) select(tab);
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target.closest && event.target.closest('[data-collection-tab]');
      if (!tab) return;

      const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[data-collection-tab]'));
      let index = tabs.indexOf(tab);

      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else return;

      event.preventDefault();
      select(tabs[index]);
      tabs[index].focus();
    });

    /* Theme editor: selecting a Tab block switches to that tab */
    document.addEventListener('shopify:block:select', (event) => {
      const tab = event.target;
      if (tab && tab.matches && tab.matches('[data-collection-tab]')) select(tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  /* Theme editor: scroll the carousel to the card that was just selected */
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target;
    if (!card || !card.closest || !card.closest('.featured-collections__track')) return;
    card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
